angular
	.module 'App.Repository'
	.factory 'RegisterRepository', ['BaseRepository', (BaseRepository) ->
		class RegisterRepository extends BaseRepository
			@resource = '/registers'
			@isRestricted = true

			getSearchQuery: ->
				query = super()
				query.with 'shop'

				return query

			removeFromDevice: (id) ->
				@patch id, {device_id: null}

		return new RegisterRepository()
	]
